import { LayoutBuilderTypeBase } from '@shared/types/process';
import {
    getDependentFieldNames,
    isHiddenByDependentFields,
} from '@shared/util/layoutDependentFields';

import { ShadcnForm } from '@shadcn-features/core';
import { useMemo } from 'react';

export function useBlockDependencyVisibility({
    dependentFields,
}: Pick<LayoutBuilderTypeBase, 'dependentFields'>) {
    const form = ShadcnForm.useFormInstance();
    const dependentFieldNames = useMemo(
        () => getDependentFieldNames(dependentFields),
        [dependentFields],
    );
    const dependentFieldValues = ShadcnForm.useWatch(
        dependentFieldNames as never,
        form,
    ) as unknown[];

    return useMemo(
        () => isHiddenByDependentFields(dependentFields, dependentFieldValues),
        [dependentFields, dependentFieldValues],
    );
}
